import React from 'react';
import { useModal } from '../../../../hooks/use-modal';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom-v5-compat';

import { Button } from 'ui-components/components/button';
import ForecastingDrawer from '../../../../components/forecasting-drawer';
import { useInventoryContext } from '../inventory-context';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useEnableReorderAssist } from '../../../../feature-flags/hooks/use-enable-reorder-assist';
import { useInventoryReorderingFeatureGate } from '../../../../feature-gates/use-inventory-reordering-feature-gate';

import messages from '../../messages';
import style from '../../../../components/grid-header/reusable-grid-button.module.less';

/**
 * ReorderButton component for opening the forecasting drawer
 * @returns {React.JSX.ReactElement} The rendered component
 */
export const ReorderButton = () => {
  const { open: openForecastingDrawer, close: closeForecastingDrawer, isOpen: isForecastingDrawerOpen } = useModal();
  const { selectedProductIds } = useInventoryContext();
  const { inventoryWarehouseId } = useParams();

  const isReorderAssistFeatureFlagEnabled = useEnableReorderAssist();
  const { isFeatureEnabled: isReorderAssistPlanEnabled } = useInventoryReorderingFeatureGate();

  const hasWarehouse = !!inventoryWarehouseId;

  // Both feature flag AND seller feature must be enabled
  const isFullyEnabled = isReorderAssistFeatureFlagEnabled && isReorderAssistPlanEnabled;

  let disabledTooltipMessage;
  if (!isReorderAssistPlanEnabled) {
    disabledTooltipMessage = <FormattedMessage {...messages.reorderButtonNotEnabledTooltip} />;
  } else if (!hasWarehouse) {
    disabledTooltipMessage = <FormattedMessage {...messages.reorderButtonRootViewTooltip} />;
  } else if (selectedProductIds.length === 0) {
    disabledTooltipMessage = <FormattedMessage {...messages.reorderButtonNoProductsTooltip} />;
  }

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={!isFullyEnabled || !hasWarehouse || selectedProductIds.length === 0}
        disabledTooltipMessage={disabledTooltipMessage}
        onClick={openForecastingDrawer}
        theme={THEME_CONSTANTS.tertiary}
      >
        <FormattedMessage {...messages.reorderButton} />
      </Button>
      {isForecastingDrawerOpen && (
        <ForecastingDrawer
          inventoryWarehouseId={inventoryWarehouseId}
          onClose={closeForecastingDrawer}
          selectedProductIds={selectedProductIds}
        />
      )}
    </>
  );
};
